import { onMounted } from 'vue';
import { useRecaptchaProvider, useChallengeV2 } from 'vue-recaptcha';

export function useRecaptchaToken() {
    useRecaptchaProvider();

    const { root, execute, onVerify, onExpired, reset } = useChallengeV2({
        options: {
            size: 'invisible',
        },
    });

    let resolveToken: ((token: string) => void) | null = null;
    let cachedToken: string | null = null;

    onVerify((token: string) => {
        const prefixed = 'v2:' + token;
        if (resolveToken) {
            resolveToken(prefixed);
            resolveToken = null;
            reset();
        } else {
            cachedToken = prefixed;
        }
    });

    onExpired(() => {
        cachedToken = null;
        reset();
        execute();
    });

    onMounted(() => {
        if (import.meta.env.VITE_RECAPTCHA_ENABLED !== 'false') {
            execute();
        }
    });

    async function getToken(): Promise<string> {
        if (import.meta.env.VITE_RECAPTCHA_ENABLED === 'false') {
            return 'e2e-test-token';
        }

        if (cachedToken) {
            const token = cachedToken;
            cachedToken = null;
            return token;
        }

        return new Promise<string>((resolve, reject) => {
            resolveToken = resolve;
            try {
                execute();
            } catch (err) {
                reject(err);
            }
        });
    }

    return { root, getToken };
}
